import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Homepage.css"
import imageUrls from "../../Data/ImageMaps";
// import RSVPForm from "../RSVPForm/RSVPForm";
import { Card, Modal, ModalDialog } from "@mui/joy";
import EventStepper from "Components/EventStepper/EventStepper";
import WeddingPartyDisplay from "Components/WeddingPartyDisplay/WeddingPartyDisplay";
import VenueDisplay from "Components/VenueDisplay/VenueDisplay";
import CountdownTimer from "Components/CountdownTimer/CountdownTimer";
import WeddingStory from "Components/WeddingStory/WeddingStory";
import { motion } from "motion/react"
import useMediaQuery from "@mui/material/useMediaQuery";
import Registry from "Components/Registry/Registry";

function Homepage() {
    const isMobile = useMediaQuery('(max-width:600px)');
    const [selectedImage, setSelectedImage] = useState(null);
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: isMobile ? "20px" : "60px",
        className: "carousel-container"
    };

    // const [rsvpFormOpen, setRsvpFormOpen] = useState(false)
    // const rsvp_form_props = {
    //     rsvp_form_open: rsvpFormOpen
    // }

    // function handle_open_rsvp_form() {
    //     setRsvpFormOpen(!rsvpFormOpen)
    // }
    function handleImageClick(imageUrl) {
        setSelectedImage(imageUrl);
    }
    return (
        <div className="homepage">
            <motion.div
                initial={{ y: 100, opacity: 0 }}
                // Start position (100px below) 
                animate={{ y: 0, opacity: 1 }}
                // End position (original position) 
                transition={{ duration: 2 }}
            // Animation duration (1 second) 
            >
                <Card className="text-bg" sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: (isMobile ? '100%' : '30%'),
                    margin: '0 auto',
                    backgroundColor: 'rgba(235, 122, 16, 0.95)',
                    borderColor: '#BF5B05'
                }}>
                    <h1 className="title">David & Tala</h1>
                    <p className="date">September 27, 2025</p>

                    <h1 className="title2">
                        Time until the big day

                        <CountdownTimer />
                    </h1>
                </Card>
            </motion.div>

            <motion.div
                initial={{ y: 200 }}
                animate={{ y: 0 }}
                // End position (original position) 
                transition={{ duration: 1 }}>

                {/* <div className="container">
                    <Button onClick={handle_open_rsvp_form}>Submit my RSVP!</Button>
                    <RSVPForm
                        rsvp_form_open={rsvp_form_props.rsvp_form_open}
                        onCloseRSVPModal={handle_open_rsvp_form} />
                </div> */}
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 100 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }} // Animation duration (1 second) 
            >
                <div className="slider-container">
                    <
                        // @ts-ignore
                        Slider {...settings}>


                        {imageUrls.map((imageUrl) => {
                            return (
                                <div key={imageUrl} className="image-container">
                                    <img className="image" width={"100%"} height={"100%"} src={imageUrl} alt="1"
                                        onClick={() => handleImageClick(imageUrl)}></img>
                                </div>
                            )
                        })}


                    </Slider>
                </div>
            </motion.div>

            <br />
            <Modal open={!!selectedImage} onClose={() => setSelectedImage(null)}>
            <ModalDialog sx={{ border: "none", boxShadow: "none", backgroundColor: "transparent", width: "auto", maxWidth: "none", padding: 0 }}>
              <div style={{ textAlign: "center" }}>
                {selectedImage && (
                  <img
                    src={selectedImage}
                    alt="Wedding Moment"
                    style={{ maxWidth: "100vw", maxHeight: "100vh", objectFit: "contain" }}
                  />
                )}
              </div>
            </ModalDialog>
          </Modal>
          
            <EventStepper />


            <WeddingPartyDisplay />

            <VenueDisplay />

            <WeddingStory />
            <Registry/>
        </div >
    );
}

export default Homepage;
